import React, { useState, useEffect, Fragment, useRef, createRef } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import { toast } from 'react-toastify';

const ProductInventory = ({
  data,
  handleValue = null,
  leadId,
  getMaterial,
  getMateriaById,
  getBrandById,
  getBrand,
  handleDataFilter = null,
  handleremoveValue = null,
  postSalesData,
  commData
}) => { 
  const objInput = { category_id: '', brand_id: '', material_id: '', quantity: '',specification:'', item_price_per_qty: ''};
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputListData3, setInputListData3] = useState('');
  const [inputListData4, setInputListData4] = useState('');
  const [inputListData5, setInputListData5] = useState('');
  const [inputListData6, setInputListData6] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [catVal, setCatVal] = useState('');
  const [materialReq, setMaterialReq] = useState('Yes');
  const [catId, setCatId] = useState('');
  const [brandId, setBrandId] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const inputRef = useRef([]);
  const [gateData, setGateData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [materialNewData, setMaterialNewData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [brands,setBrands] = useState([]);
  // const [editInput, setEditInput] = useState([]);
  // const [isEditData, setIsEditData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [subAmount, setSubAmount] = useState(0);
  const [leadTypeIdVal, setLeadTypeId] = useState('');
  const [commTypeIdVal, setCommTypeId] = useState('');
  
  useEffect(() => {
    if(commData !== null) { 
      const leadTypeId = commData?.leadType;
      const commTypeId = commData?.commercialData?.commercial_type_id;
      setLeadTypeId(leadTypeId);
      setCommTypeId(commTypeId);
    }
  },[commData]);

  const handleData = () => {
    if (data) {
      setGateData(data);
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      handleData();
    }
  }, [data]);

  const addGates = () => {
    if (
      !inputListData1 ||
      !inputListData2 ||
      !inputListData3 ||
      !inputListData4 ||
      isError
      // !inputListData1.length ||
      // !inputListData2.length ||
      // !inputListData3.length
    ) {
      setIsError(true);
      return false;
    }
    setInputValue([
      ...inputValue,
      { category_id: '', material_id: '', brand_id: '', quantity: '',specification:'', item_price_per_qty:''},
    ]);

    // if (inputListData1?.id) {
    if (inputListData1) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }

    setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
    setIsError(false);
    setInputListData1('');
    setInputListData2('');
    setInputListData3('');
    setInputListData4('');
    setInputListData5('');
    setInputListData6('');
  };
  const removeGate = (index = null) => {
    setInputListData1(inputValue[index]?.category_id);
    setInputListData2(inputValue[index]?.quantity);
    setInputListData3(inputValue[index]?.material_id);
    setInputListData4(inputValue[index]?.brand_id);
    setInputListData5(inputValue[index]?.specification);
    setInputListData6(inputValue[index]?.item_price_per_qty);
    let removeArray = inputValue.splice(index + 1, 1);
    inputList.splice(index, 1);
    setInputValue([...inputValue]);
    setInputList([...inputList]);
    if (handleremoveValue) {
      handleremoveValue(removeArray);
    }
  };

  const handleInitalValue = () => {
    setCatVal('');
    setNumberVal('');
    setInputValue([objInput]);
    if (handleremoveValue) {
      handleremoveValue([]);
    }
  };

  const handleFormData = () => {
    if (inputValue) {
      handleValue({
        productData: inputValue,
        materialRequired: materialReq,
      });
    } else {
      
      handleValue({materialRequired: materialReq});
    }
  };

  useEffect(() => {
    handleFormData();
  }, [inputValue]);
  
  useEffect(() => {
    handleFormData();
  }, [materialReq]);

  useEffect(() => {
    if (catId) {
      (async () => {
        setIsLoading(true);
      let getBrand = await getBrandById(catId);
      let list = [...brands];
      if(getBrand){
        
        list[isCurrentRef] = getBrand;
        console.log(list)
        setBrandData(list);
        setBrands(list);
        
      }else{
        list[isCurrentRef] = getBrand;
        console.log(list)
        setBrandData(list);
        setBrands(list);
      }
        // await getMateriaById(catId);
        setIsLoading(false);
      })();
    }
  }, [catId]);

  useEffect(() => {
    if (brandId) {
      (async () => {
        setIsLoading(true);
        console.log(brandId)
        let categoryIds = [...inputValue];
        console.log(categoryIds);
        if(categoryIds[isCurrentRef].category_id){
          
          let materialsData = await getMateriaById(categoryIds[isCurrentRef].category_id,brandId);
          let listMat = [...materialNewData];
          if(materialsData){
            
            listMat[isCurrentRef] = materialsData;
            console.log(listMat)
            setMaterialNewData(listMat);
            
            
          }else{
          
            listMat[isCurrentRef] = materialsData;
            console.log(listMat)
            setMaterialNewData(listMat);
            
          }
          console.log(materialsData);
        }else{
          toast.error('Category Not selected')
        }
        // let materialsData = await getMateriaById(null,brandId);
        // setMaterialNewData
        
        setIsLoading(false);
      })();
    }
  }, [brandId]);

  useEffect(() => {
    if (getMaterial) {
      setMaterialData(getMaterial);
    }
  }, [getMaterial]);

  useEffect(() => {
    if (getBrand) {
      setBrandData(getBrand);
    }
  }, [getBrand]);

  const handleInputValue = (val, key, index) => {
    const list = [...inputValue];
    list[index][key] = val;
    setInputValue([...list]);
  };

  useEffect(() => {
     if(inputValue !== undefined && inputValue?.length > 0) {
        let amt = 0;
        inputValue.map((value) => {
          if(value.quantity !== '' && value.item_price_per_qty !== '') {
             amt += parseFloat(value.quantity) * parseFloat(value.item_price_per_qty);
          }
        });
        setSubAmount(amt);
     }
  },[inputValue]);

  return (
    <Fragment>
      <FormSection title={localization.productInventory} isLoading={isLoading}>
      {leadTypeIdVal === 1 && commTypeIdVal === 5 && false && <div className='mb-4'><b>Total Amount : </b> {subAmount}</div>}
      {/* {(postSalesData?.hardware?.length>0)?
            editInput &&
            editInput.map((item, index) => {
              return(
                <div key={item.id} className="w-100 row mx-0">
                <div className="row mx-0" ref={inputRef.current[index + 1]}>
                  <DropDownInput
                    label={localization.selectCategory}
                    data={gateData}
                    getIdValue={(val) => {
                      setInputListData1(val.value);
                      setIsCurrentRef(index + 1);
                      setCatId(val.id);
                      handleInputValue(val.id, 'category_id', index);
                    }}
                    value={item.category_name}
                    // errorMsg={localization.isRequired}
                    // required
                    // isStarRequired={true}
                  />
                  
                  {inputValue[index]?.category_id && (
                    <DropDownInput
                      label={localization.selectMaterial}
                      data={materialData.length === 0 ? [] : materialData}
                      getIdValue={(val) => {
                        setIsCurrentRef(index + 1);
                        setInputListData3(val.value);
                        handleInputValue(val.id, 'material_id', index);
                      }}
                      errorMsg={localization.isRequired}
                      required
                      isStarRequired={true}
                      value={item.material_name}
                    />
                  )}

                  <ConstantInput
                    label={localization.quantity}
                   
                    type="number"
                    min={0}
                    handleChange={(val) => {
                      setInputListData2(val);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val, 'quantity', index);
                      setIsError(
                        !Regex.numericNotZero.test(
                          item?.quantity
                        )
                      );
                    }}
                    value={item.quantity}
                    // required
                    // isStarRequired={true}
                  />
                  <div>
                    <ButtonWithIcon
                      title="Remove"
                      onClick={() => removeGate(index)}
                    />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
         
              );
               })
        :
          <> */}
        <div className="w-100 row mx-0">
        {/* <DropDownInput
              label={localization.materialRequired}
              data={[
                {"id":"Yes", "name":"Yes"},
                {"id":"No", "name":"No"}
              ]}
              getIdValue={(val) => {
                setMaterialReq(val.value);
              }}
              // errorMsg={localization.isRequired}
              value={materialReq}
              // required
              // isStarRequired={true}
            /> */}
          <div
            ref={inputRef.current[0]}
            className="row mx-0"
            // disabled={catVal && numberVal ? true : false}
          >
            <div className='row'>
              <div className='col-md-3'>
                  <DropDownInput
                  label={localization.selectCategory}
                  data={gateData}
                  getIdValue={(val) => {
                    setCatVal(val.value);
                    setCatId(val.id);
                    setInputListData1(val.value);
                    setIsCurrentRef(0);
                    handleInputValue(val.id, 'category_id', 0);
                  }}
                  // errorMsg={localization.isRequired}
                  value={catVal}
                  // required
                  // isStarRequired={true}
                />
              </div>
              {inputValue[0]?.category_id && brands[0] && (
              <div className='col-md-3'>
                  <DropDownInput
                    label={localization.selectBrand}
                    data={brands[0]}
                    getIdValue={(val) => {
                      setIsCurrentRef(0);
                      setBrandId(val.id)
                      setInputListData4(val.value);
                      handleInputValue(val.id, 'brand_id', 0);
                    }}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                  />
                
              </div>
              )}
              {inputValue[0]?.category_id && materialNewData[0]  && (
              <div className='col-md-3'>
                  <DropDownInput
                    label={localization.selectMaterial}
                    data={materialNewData[0]}
                    getIdValue={(val) => {
                      setIsCurrentRef(0);
                      setInputListData3(val.value);
                      handleInputValue(val.id, 'material_id', 0);
                    }}
                    errorMsg={localization.requiredselectMaterial}
                    required
                    isStarRequired={true}
                  />
                
              </div>
              )}
              <div className='col-md-3'>
                  <ConstantInput
                  label={localization.quantity}
                  /* errorMsg={
                    inputValue[0].quantity
                      ? localization.numberError
                      : localization.isRequired
                  } */
                  // regex={Regex.numericNotZero.test(inputValue[0].quantity)}
                  type="number"
                  value={numberVal}
                  handleChange={(val) => {
                    // setNumberVal(val);
                    setInputListData2(val);
                    setIsCurrentRef(0);
                    handleInputValue(val, 'quantity', 0);
                    setIsError(!Regex.numericNotZero.test(inputValue[0]?.quantity));
                  }}
                  required
                  isStarRequired={true}
                  min={0}
                />
              </div>
             {leadTypeIdVal === 1 && commTypeIdVal === 5 && false && 
               <div className='col-md-3'>
                  <ConstantInput
                    label={localization.unitPrice}
                    type="number"
                    min={1}
                    handleChange={(val) => {
                      setInputListData6(val);
                      setIsCurrentRef(0);
                      handleInputValue(val, 'item_price_per_qty', 0);
                      setIsError(
                        !Regex.numericNotZero.test(
                          inputValue[0]?.item_price_per_qty
                        )
                      );
                    }}
                    required
                    isStarRequired={true}
                />
              </div>
             }

              <div className='col-md-3'>
                  <ConstantInput
                  label={localization.specification}
                  
                  type="text"
                  value={numberVal}
                  handleChange={(val) => {
                    // setNumberVal(val);
                    setInputListData5(val);
                    setIsCurrentRef(0);
                    handleInputValue(val, 'specification', 0);
                    
                  }}
                  
                  // min={0}
                />
              </div>
              <div className='col-md-3'>
                <div>
                {inputList.length === 0 && catVal && numberVal ? (
                  <Fragment>
                    <ButtonWithIcon
                      onClick={handleInitalValue}
                      title={localization.clear}
                    />
                    <br />
                    
                  </Fragment>
                ) : null}
              </div>
              </div>
            </div>
           

          </div>
        </div>
        {inputList && inputList?.length > 0 &&
          inputList.map((item, index) => {
            return (
              <>
              <hr />
              <div key={item.id} className="w-100 row mx-0">
                <div className="row mx-0" ref={inputRef.current[index + 1]}>
                  <div className='row'>
                    <div className='col-md-3'>
                      <DropDownInput
                      label={localization.selectCategory}
                      data={gateData}
                      getIdValue={(val) => {
                        setInputListData1(val.value);
                        setIsCurrentRef(index + 1);
                        setCatId(val.id);
                        handleInputValue(val.id, 'category_id', index + 1);
                      }}
                      
                      // errorMsg={localization.isRequired}
                      // required
                      // isStarRequired={true}
                    />
                    </div>
                    {console.log(materialNewData)}
                    {inputValue[index + 1].category_id && brands[index + 1] && (
                    <div className='col-md-3'>
                      <DropDownInput
                        label={localization.selectBrand}
                        data={brands[index+1].length === 0 ? [] : brands[index+1]}
                        getIdValue={(val) => {
                          setIsCurrentRef(index + 1);
                          setBrandId(val.id)
                          setInputListData4(val.value);
                          handleInputValue(val.id, 'brand_id', index + 1);
                        }}
                        errorMsg={localization.isRequired}
                        required
                        isStarRequired={true}
                      />
                    </div>
                    )}
                    {inputValue[index + 1].category_id && materialNewData[index+1] && (
                    <div className='col-md-3'>
                      <DropDownInput
                        label={localization.selectMaterial}
                        data={materialNewData[index+1].length === 0 ? [] : materialNewData[index+1]}
                        getIdValue={(val) => {
                          setIsCurrentRef(index + 1);
                          setInputListData3(val.value);
                          handleInputValue(val.id, 'material_id', index + 1);
                        }}
                        errorMsg={localization.isRequired}
                        required
                        isStarRequired={true}
                      />
                    </div>
                    )}
                    <div className='col-md-3'>
                      <ConstantInput
                      label={localization.quantity}
                      /* errorMsg={
                        inputValue[index + 1].quantity
                          ? localization.numberError
                          : localization.isRequired
                      }
                      regex={Regex.numericNotZero.test(
                        inputValue[index + 1].quantity
                      )} */
                      type="number"
                      min={1}
                      handleChange={(val) => {
                        setInputListData2(val);
                        setIsCurrentRef(index + 1);
                        handleInputValue(val, 'quantity', index + 1);
                        setIsError(
                          !Regex.numericNotZero.test(
                            inputValue[index + 1]?.quantity
                          )
                        );
                      }}
                      required
                      isStarRequired={true}
                    />
                    </div>
                    {leadTypeIdVal === 1 && commTypeIdVal === 5 && false && 
                      <div className='col-md-3'>
                        <ConstantInput
                        label={localization.unitPrice}
                        type="number"
                        min={1}
                        handleChange={(val) => {
                          setInputListData6(val);
                          setIsCurrentRef(index + 1);
                          handleInputValue(val, 'item_price_per_qty', index + 1);
                          setIsError(
                            !Regex.numericNotZero.test(
                              inputValue[index + 1]?.item_price_per_qty
                            )
                          );
                        }}
                        required
                        isStarRequired={true}
                      />
                      </div>
                    }

                    <div className='col-md-3'>
                      <ConstantInput
                      label={localization.specification}
                      
                      type="text"
                      value={numberVal}
                      handleChange={(val) => {
                        // setNumberVal(val);
                        setInputListData5(val);
                        setIsCurrentRef(index + 1);
                        handleInputValue(val, 'specification', index + 1);
                        
                      }}
                      
                      min={0}
                    />
                  </div>
                    <div className='col-md-3'>
                        <div>
                        <ButtonWithIcon
                          title="Remove"
                          onClick={() => removeGate(index)}
                        />
                      <br />
                      
                      </div>
                    </div>
                  </div>
                  
                 
                  
                 
                </div>
              </div>
              </>
            );
          })}
           {/* </>
        } */}
        <span>
          {isError ? (
            <label className="error d-block">{localization.enterField}</label>
          ) : null}
        </span>
        <div className="w-100">
          <ButtonWithIcon
            title={localization.addMoreGates}
            onClick={addGates}
          />
        </div>
      </FormSection>
    </Fragment>
  );
};

export default ProductInventory;
